export const en = {
    'card-information.header.label': 'Card information',
    'card.number.placeholder': '1234 1234 1234 1234',
    'card.number.aria-label': 'Card number',
    'card.number.errors.required': 'Card number is required',
    'card.number.errors.min-length': 'Minimum number of digits is 13',
    'card.number.errors.invalid-number': 'Invalid card number',
    'card.save.label': 'Save payment details for future use',
    'card.saved-cards.choose-card.label': 'Choose card',
    'card.saved-cards.clear-card.label': 'Clear',
    'card.saved-cards.saved-card.aria-label': 'The card ending in',
    'card.billing-name.placeholder': 'Name on card',
    'card.billing-name.aria-label': 'Name on card',
    'card.billing-name.errors.required': 'Full name is required',
    'card.billing-name.errors.min-length': 'Full name is too short',
    'card.expiry.placeholder': 'MM / YY',
    'card.expiry.aria-label': 'Card expiration',
    'card.expiry.errors.required': 'Expiration date is required',
    'card.expiry.errors.pattern': 'Expiration date format is not valid (MM/YY)',
    'card.expiry.errors.expired': 'Your card is expired',
    'card.cvc.placeholder': 'CVC',
    'card.cvc.aria-label': 'Card CVC',
    'card.cvc.errors.required': 'Security code is required',
    'card.cvc.errors.min-length': 'Security code is too short',
    'card.cvc.errors.max-length': 'Security code is too long',
    'billing-address.same-as-shipping.label': 'Billing address is the same as shipping',
    'billing-address.country.placeholder': 'Country',
    'billing-address.country.aria-label': 'Country',
    'billing-address.country.errors.required': 'Country is required',
    'billing-address.zip.placeholder': 'Zip/Postal code',
    'billing-address.zip.aria-label': 'Zip/Postal code',
    'billing-address.zip.errors.required': 'Zip/Postal code is required',
    'billing-address.zip.errors.min-length': 'Zip/Postal code is too short',
    'pay-button.label': 'Pay',
    'pay-button.aria-label': 'Pay',
    'payment-methods.card.label': 'Card',
    'payment-methods.show-less.label': 'Show less',
    'payment-methods.show-more.label': 'Show more',
    'payment-methods.paypal.label': 'PayPal',
    'payment-methods.paypal.aria-label': 'Pay with PayPal',
    'payment-methods.klarna.label': 'Klarna',
    'payment-methods.klarna.aria-label': 'Pay with Klarna',
    'payment-methods.applepay.label': 'Apple Pay',
    'payment-methods.applepay.aria-label': 'Pay with Apple Pay',
    'payment-methods.googlepay.label': 'Google Pay',
    'payment-methods.googlepay.aria-label': 'Pay with Google Pay',
    'payment-success-state.label': 'Payment Succeeded',
    'redirect-note.label': 'After submitting your order, you will be securely redirected to complete your purchase.',
    'error.invalid_cvc': 'Invalid CVC',
    'error.authorization_required': 'Authorization Required',
    'error.contact_card_issuer': 'Contact Card Issuer',
    'error.unsupported_card': 'Unsupported Card',
    'error.insufficient_funds': 'Insufficient Funds',
    'error.unsupported_currency': 'Unsupported Currency',
    'error.card_rejected': 'Card Rejected',
    'error.expired_card': 'Expired Card',
    'error.suspected_fraud': 'Suspected Fraud',
    'error.general_decline': 'General Decline',
    'error.incorrect_number': 'Incorrect Number',
    'error.incorrect_pin': 'Incorrect Pin',
    'error.invalid_address': 'Invalid Address',
    'error.invalid_card_or_account': 'Invalid Card or Account',
    'error.invalid_amount': 'Invalid Amount',
    'error.invalid_date': 'Invalid Date',
    'error.lost_restricted_or_stolen_card': 'Lost, Restricted or Stolen Card',
    'error.blocked_list': 'Blocked List',
    'error.not_permitted': 'Not Permitted',
    'error.offline_or_online_pin_required': 'Offline or Online Pin Required',
    'error.pin_retry_exceeded': 'Pin Retry Exceeded',
    'error.processing_error': 'Processing Error',
    'error.withdrawal_count_limit_exceeded': 'Withdrawal Count Limit Exceeded',
    'error.unknown': 'Unknown error',
    'error.fraud': 'Fraud',
    'error.three_d_secure': '3DS Failed',
    'error.custom_rule': 'Custom Rule',
};
export default en;
//# sourceMappingURL=en.translation.js.map